<ngx-spinner bdColor="rgba(0, 111, 155, 0.60)" size="medium" color="#fff" type="ball-clip-rotate-multiple">
  <p style="color: white; font-style: italic; margin-top: 1%;margin-bottom: 1%;"> Cargando... </p>
</ngx-spinner>
<!--<mat-sidenav-container class="sidenavcontainer">
  <mat-sidenav (closedStart)="cerrarSideNav()" mode="push" #sideNav class="sidenav" fixedInViewport="true"
    position="end">
    <div *ngIf="loading" style="width: 350px;">
      <mat-spinner style="margin: 0 auto;"></mat-spinner>
    </div>
    <div class="sidenav-container" *ngIf="!loading">

      <mat-expansion-panel hideToggle [expanded]="true" *ngIf="linkHome != null">
        <mat-expansion-panel-header (click)="cerrarSideNav()" [routerLink]="linkHome.path">

          <mat-panel-title>
            <div class="d-flex align-items-center justify-content-start">
              <p>
                Home

              </p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>



      <mat-expansion-panel *ngIf="(isInRole('ADM') || isInRole('ADM LOCAL')) && isLogged()" #expansionPanelADM>
        <mat-expansion-panel-header>

          <mat-panel-title>
            <div class="d-flex align-items-center justify-content-start">
              <p>
                ADM

              </p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-selection-list [multiple]="false" #admLinks>
          <mat-list-option (click)="cerrarSideNav()" [routerLink]="link.path"
            *ngFor="let link of logged?.linksADM; let i = index" [value]="link">


            <a [routerLink]="link.path">

              <div class="d-flex align-items-center justify-content-start gap-3">
                <mat-icon matListIcon color="accent-darker">{{link.icon}}</mat-icon>
                <p>
                  {{link.text}}

                </p>
              </div>

              <mat-divider>
              </mat-divider>
            </a>
          </mat-list-option>

        </mat-selection-list>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="isLogged()" #expansionPanelPedidos>
        <mat-expansion-panel-header>

          <mat-panel-title>
            <div class="d-flex align-items-center justify-content-start">
              <p>
                Pedidos

              </p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-selection-list [multiple]="false" #pedidosLinks>
          <mat-list-option (click)="cerrarSideNav()" [routerLink]="link.path"
            *ngFor="let link of logged?.linksPedidos; let i = index" [value]="link">


            <a [routerLink]="link.path">

              <div class="d-flex align-items-center justify-content-start gap-3">
                <mat-icon matListIcon color="accent-darker">{{link.icon}}</mat-icon>
                <p>
                  {{link.text}}

                </p>
              </div>

              <mat-divider>
              </mat-divider>
            </a>
          </mat-list-option>

        </mat-selection-list>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="(isInRole('ADM') || isInRole('ADM LOCAL')) && isLogged()" #expansionPanelCuentas>
        <mat-expansion-panel-header>

          <mat-panel-title>
            <div class="d-flex align-items-center justify-content-start">

              <p>
                Cuentas

              </p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-selection-list [multiple]="false" #cuentasLinks>
          <mat-list-option (click)="cerrarSideNav()" [routerLink]="link.path"
            *ngFor="let link of logged?.linksCuentas; let i = index" [value]="link">


            <a [routerLink]="link.path">

              <div class="d-flex align-items-center justify-content-start gap-3">
                <mat-icon matListIcon color="accent-darker">{{link.icon}}</mat-icon>
                <p>
                  {{link.text}}

                </p>
              </div>

              <mat-divider>
              </mat-divider>
            </a>
          </mat-list-option>

        </mat-selection-list>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="(isInRole('ADM') || isInRole('ADMVENTAS') || isInRole('ADM LOCAL')) && isLogged()"
        #expansionPanelProductos>
        <mat-expansion-panel-header>

          <mat-panel-title>
            <div class="d-flex align-items-center justify-content-start">

              <p>
                Productos

              </p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-selection-list [multiple]="false" #tablasLinks>
          <mat-list-option (click)="cerrarSideNav()" [routerLink]="link.path"
            *ngFor="let link of logged?.linksProductos; let i = index" [value]="link">
            
            <a [routerLink]="link.path">

              <div class="d-flex align-items-center justify-content-start gap-3">
                <mat-icon matListIcon color="accent-darker">{{link.icon}}</mat-icon>
                <p>
                  {{link.text}}

                </p>
              </div>

              <mat-divider>
              </mat-divider>
            </a>
          </mat-list-option>

        </mat-selection-list>

      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="(isInRole('ADM') || isInRole('ADMVENTAS') || isInRole('ADM LOCAL')) && isLogged()"
        #expansionPanelTablas>
        <mat-expansion-panel-header>

          <mat-panel-title>
            <div class="d-flex align-items-center justify-content-start">
              <p>
                Tablas

              </p>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-selection-list [multiple]="false" #tablasLinks>
          <mat-list-option (click)="cerrarSideNav()" [routerLink]="link.path"
            *ngFor="let link of logged?.linksTablas; let i = index" [value]="link">


            <a [routerLink]="link.path">

              <div class="d-flex align-items-center justify-content-start gap-3">
                <mat-icon matListIcon color="accent-darker">{{link.icon}}</mat-icon>
                <p>
                  {{link.text}}

                </p>
              </div>

              <mat-divider>
              </mat-divider>
            </a>
          </mat-list-option>

        </mat-selection-list>

      </mat-expansion-panel>

      <div class="d-flex justify-content-evenly align-items-center pie-sidenav">
        <div style="width:40%;" class="d-flex justify-content-between align-items-center me-2 ms-4">

          <button (click)="cambioClave()" mat-button color="accent-darker">
            <mat-icon>key</mat-icon>
            {{Etiquetas.CambiarClave}}
          </button>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <mat-divider class="mat-divider-login" [vertical]="true"></mat-divider>

        </div>
        <div style="width:40%;" class="d-flex justify-content-evenly align-items-center ms-2 me-4">

          <button (click)="logOut()" mat-button color="accent-darker">
            <mat-icon>logout</mat-icon>
            {{Etiquetas.CerrarSesion}}
          </button>

        </div>

      </div>
    </div>

  </mat-sidenav>
  <mat-sidenav-content class="mat-sidenav-content">
    <div class="grid-xy">

      <app-header></app-header>

      <div class="maincontainersidenav">
        <div class="router-outlet">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container> -->

<mat-drawer-container class="example-container mat-typography" autosize>
  <mat-drawer #drawer mode="side" disableClose="true" opened="true">
    <div class="d-flex flex-column justify-content-center align-items-center">

      <button [routerLink]="linkHome.path" (click)="isExpanded = false" mat-mini-fab color="warn" style="margin: 10px;">
        <mat-icon aria-label="Menu">home</mat-icon>
      </button>
      <!-- <button *ngIf="isLogged()" mat-mini-fab (click)="isExpanded = !isExpanded" color="warn" style="margin: 10px;">
        <mat-icon aria-label="Menu">menu</mat-icon>
      </button> -->


    </div>
    <mat-nav-list>
      <mat-list-item *ngIf="logged?.linksADM.length" [matMenuTriggerFor]="menuADM">

        <mat-icon matTooltip="ADM">{{Etiquetas.IconoADM}}</mat-icon>

        <mat-menu #menuADM="matMenu">
          <a *ngFor="let l of logged?.linksADM" [routerLink]="l.path" (click)="isExpanded = false" mat-menu-item>
            <mat-icon>{{l.icon}}</mat-icon>
            <span>{{l.text}}</span>
          </a>
        </mat-menu>
        <h4 mat-line *ngIf="isExpanded">ADM</h4>
      </mat-list-item>

      <mat-list-item *ngIf="logged?.linksCuentas.length" [matMenuTriggerFor]="menuCuentas">

        <mat-icon matTooltip="Cuentas">{{Etiquetas.IconoCuentas}}</mat-icon>

        <mat-menu #menuCuentas="matMenu">
          <a *ngFor="let l of logged?.linksCuentas" [routerLink]="l.path" (click)="isExpanded = false" mat-menu-item>
            <mat-icon>{{l.icon}}</mat-icon>
            <span>{{l.text}}</span>
          </a>
        </mat-menu>
        <h4 mat-line *ngIf="isExpanded">Cuentas</h4>
      </mat-list-item>

      <mat-list-item *ngIf="logged?.linksPedidos.length" [matMenuTriggerFor]="menuPedidos">

        <mat-icon matTooltip="Pedidos">{{Etiquetas.IconoPedidos}}</mat-icon>

        <mat-menu #menuPedidos="matMenu">
          <a *ngFor="let l of logged?.linksPedidos" [routerLink]="l.path" (click)="isExpanded = false" mat-menu-item>
            <mat-icon>{{l.icon}}</mat-icon>
            <span>{{l.text}}</span>
          </a>
        </mat-menu>
        <h4 mat-line *ngIf="isExpanded">Pedidos</h4>
      </mat-list-item>
      <mat-list-item *ngIf="logged?.linksReportes.length" [matMenuTriggerFor]="menuReportes">

        <mat-icon matTooltip="Reportes">{{Etiquetas.IconoReportes}}</mat-icon>

        <mat-menu #menuReportes="matMenu">
          <a *ngFor="let l of logged?.linksReportes" [routerLink]="l.path" (click)="isExpanded = false" mat-menu-item>
            <mat-icon>{{l.icon}}</mat-icon>
            <span>{{l.text}}</span>
          </a>
        </mat-menu>
        <h4 mat-line *ngIf="isExpanded">Reportes</h4>
      </mat-list-item>

      <mat-list-item *ngIf="logged?.linksProductos.length" [matMenuTriggerFor]="menuProductos">

        <mat-icon matTooltip="Productos">{{Etiquetas.IconoProductos}}</mat-icon>

        <mat-menu #menuProductos="matMenu">
          <a *ngFor="let l of logged?.linksProductos" [routerLink]="l.path" (click)="isExpanded = false" mat-menu-item>
            <mat-icon>{{l.icon}}</mat-icon>
            <span>{{l.text}}</span>
          </a>
        </mat-menu>
        <h4 mat-line *ngIf="isExpanded">Productos</h4>
      </mat-list-item>

      <mat-list-item *ngIf="logged?.linksTablas.length" [matMenuTriggerFor]="menuTablas">

        <mat-icon matTooltip="Tablas">{{Etiquetas.IconoTablas}}</mat-icon>

        <mat-menu #menuTablas="matMenu">
          <a *ngFor="let l of logged?.linksTablas" [routerLink]="l.path" (click)="isExpanded = false" mat-menu-item>
            <mat-icon>{{l.icon}}</mat-icon>
            <span>{{l.text}}</span>
          </a>
        </mat-menu>
        <h4 mat-line *ngIf="isExpanded">Tablas</h4>
      </mat-list-item>



    </mat-nav-list>
  </mat-drawer>

  <div class="grid-xy">

    <app-header></app-header>

    <div class="maincontainersidenav">
      <div class="router-outlet">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</mat-drawer-container>